module.exports = __webpack_public_path__ + "fonts/NanumBarunGothic.06c8215.ttf";